import * as React from 'react'
import { ChevronDownIcon } from '@/src/icons'

import { cn } from '@/registry/reapit/lib/utils'

function NativeSelect({
  className,
  size = 'medium',
  ...props
}: Omit<React.ComponentProps<'select'>, 'size'> & { size?: 'small' | 'medium' | 'large' }) {
  return (
    <div
      className="group/native-select relative w-fit has-[select:disabled]:opacity-50"
      data-slot="native-select-wrapper"
    >
      {/* DS NativeSelect sizes:
          small  — h-8  (32px), px-2.5, text-xs  (compact)
          medium — h-9  (36px), px-3,   text-base (default)
          large  — h-10 (40px), px-4,   text-base
          Icon: DS icon-md (20px / size-5) for trailing chevron */}
      <select
        data-slot="native-select"
        data-size={size}
        className={cn(
          'w-full min-w-0 appearance-none rounded-md border border-input bg-transparent pr-9 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground placeholder:text-text-placeholder disabled:pointer-events-none disabled:cursor-not-allowed dark:bg-input/30 dark:hover:bg-input/50',
          'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
          'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
          'data-[size=small]:h-8 data-[size=small]:px-2.5 data-[size=small]:py-1 data-[size=small]:text-xs',
          'data-[size=medium]:h-9 data-[size=medium]:px-3 data-[size=medium]:py-2 data-[size=medium]:text-base',
          'data-[size=large]:h-10 data-[size=large]:px-4 data-[size=large]:py-2.5 data-[size=large]:text-base',
          className,
        )}
        {...props}
      />
      {/* DS: trailing chevron is icon-md (20px) */}
      <ChevronDownIcon
        className="pointer-events-none absolute top-1/2 right-3.5 size-5 -translate-y-1/2 text-muted-foreground opacity-50 select-none"
        aria-hidden="true"
        data-slot="native-select-icon"
      />
    </div>
  )
}

function NativeSelectOption({ ...props }: React.ComponentProps<'option'>) {
  return <option data-slot="native-select-option" {...props} />
}

function NativeSelectOptGroup({ className, ...props }: React.ComponentProps<'optgroup'>) {
  return <optgroup data-slot="native-select-optgroup" className={cn(className)} {...props} />
}

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption }
